import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-583b6cc1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-container" }

import { ref, computed } from "vue";
import { useAuthStore } from "@/store/auth/login";

import InnerPageLayout from "@/widgets/layouts/InnerPageLayout.vue";
import TopWorkbookPanel from "@/entities/dictionaries/workbooks/panels/TopWorkbookPanel.vue";
import WorkbookCreateForm from "@/entities/dictionaries/workbooks/forms/WorkbookCreateForm.vue";
import HandlerAccessDenied from "@/shared/base/HandlerAccessDenied.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkbookPage',
  setup(__props) {

const isLoading = ref(false);
const createFormRef = ref(null);
const authStore = useAuthStore();

const createWorkbook = () => {
  if (createFormRef.value) createFormRef.value.createWorkbook();
};

const setLoading = (value: boolean) => {
  isLoading.value = value;
};

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions(
    ["system:read", "system:edit"],
    ["dictionaries:read", "dictionaries:edit"],
    ["analytics:read", "analytics:edit"]
  );
});

const isButtonDenied = computed(() => {
  return authStore.isDeniedForPermissions(
    ["system:edit"],
    ["dictionaries:edit"],
    ["analytics:edit"]
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InnerPageLayout, null, {
    default: _withCtx(() => [
      _createVNode(HandlerAccessDenied, { "is-denied": isDenied.value }, {
        default: _withCtx(() => [
          _createVNode(TopWorkbookPanel, {
            isLoading: isLoading.value,
            isButtonDisabled: isButtonDenied.value,
            onCreateWorkbook: createWorkbook
          }, null, 8, ["isLoading", "isButtonDisabled"]),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(WorkbookCreateForm, {
              isLoading: isLoading.value,
              onSetLoading: setLoading,
              ref_key: "createFormRef",
              ref: createFormRef
            }, null, 8, ["isLoading"])
          ])
        ]),
        _: 1
      }, 8, ["is-denied"])
    ]),
    _: 1
  }))
}
}

})